import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Loader from '../../components/loader';

const bankDetails = {
  toName: 'Sequoyah Vaulting ApS',
  IBAN: 'PL62102010682974000051086406',
  BIC: 'BPKOPLPWXXX',
  bankName: 'PKO BP S.A',
};

class EurTrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      termsAgreed: false,
    };
    this.copyConfirm = this.copyConfirm.bind(this);
  }

  toggleTerms() {
    const { termsAgreed } = this.state;
    this.setState({termsAgreed: !termsAgreed});
  }

  copyConfirm(id) {
    if (id) {
      if (document.getElementById(id)) {
        document.getElementById(id).style.color = "rgb(36, 195, 126)";
        setTimeout(() => {
          document.getElementById(id).style.color = "unset";
        }, 400);
      }
    }
  }

  render() {
    const { user } = this.props;
    const { termsAgreed } = this.state;

    const referenceId = user?.me?.referenceId || '';

    return (
      <div className="grid-x grid-margin-x">
        <div className="cell panel ann gold small-12 medium-12 large-12">
          <div className="ann-top">
            <div className="ann-head">
              <h2>Purchase Gold with Euro <b>(BETA)</b></h2>
            </div>
          </div>
          <div className="ann-body">
            <p style={{marginBottom: '6px'}}>
              We are happy to introduce a new and easy way of buying gold.
            </p>
          </div>
        </div>

        <div className="cell small-12 medium-12 large-5">
          <div className="cell panel">
            <h2 style={{marginTop: 0, marginBottom: 0}}>
              How It Works
            </h2>
            <hr />
            <div className="grid-x">
              <ul style={{display: 'flex', flexDirection: 'column', gap: '12px', paddingLeft: 12, margin: 0}}>
                <li>
                  Read and agree to the additional terms.
                </li>
                <li>
                  Take note of your <b>personal reference number</b>.
                </li>
                <li>
                  Send a EURO SEPA transfer to the designated bank account <b>(current minimum of €5000)</b> with your personal reference number.
                </li>
                <li>
                  When the money arrives at the destination bank account, the gold will be traded and credited to your account manually by our trading personnel.
                </li>
                <li>
                  You will be notified via email when your purchase is complete and the gold is credited to your account.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {termsAgreed ? (
          <div className="cell panel small-12 medium-12 large-7">
            <h2 style={{marginTop: 0, marginBottom: 0}}>
              Bank Account Information
            </h2>
            <hr />
            <div className="grid-x">
              <div className="small-12">
                <p style={{marginTop: 0}}>
                  Send a minumum of:
                </p>
                <p>
                  <b>€5000</b>
                </p>
                <p>
                  From a Bank Account in your name to:
                </p>
                <p style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span><b>{bankDetails.toName}</b></span>
                  <CopyToClipboard
                    text={bankDetails.toName}
                    onCopy={() => this.copyConfirm('toName')}
                  >
                    <b
                      id='toName'
                      style={{cursor: 'pointer'}}
                    >
                      <FontAwesomeIcon
                        icon={faCopy}
                        className={'copy-icon'}
                      />
                    </b>
                  </CopyToClipboard>
                </p>
                <p style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span>IBAN: <b>{bankDetails.IBAN}</b></span>
                  <CopyToClipboard
                    text={bankDetails.IBAN}
                    onCopy={() => this.copyConfirm('IBAN')}
                  >
                    <b
                      id='IBAN'
                      style={{cursor: 'pointer'}}
                    >
                      <FontAwesomeIcon
                        icon={faCopy}
                        className={'copy-icon'}
                      />
                    </b>
                  </CopyToClipboard>
                </p>
                <p style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span>BIC: <b>{bankDetails.BIC}</b></span>
                  <CopyToClipboard
                    text={bankDetails.BIC}
                    onCopy={() => this.copyConfirm('BIC')}
                  >
                    <b
                      id='BIC'
                      style={{cursor: 'pointer'}}
                    >
                      <FontAwesomeIcon
                        icon={faCopy}
                        className={'copy-icon'}
                      />
                    </b>
                  </CopyToClipboard>
                </p>
                <p style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span>Bank Name: <b>{bankDetails.bankName}</b></span>
                  <CopyToClipboard
                    text={bankDetails.bankName}
                    onCopy={() => this.copyConfirm('bankName')}
                  >
                    <b
                      id='bankName'
                      style={{cursor: 'pointer'}}
                    >
                      <FontAwesomeIcon
                        icon={faCopy}
                        className={'copy-icon'}
                      />
                    </b>
                  </CopyToClipboard>
                </p>
                <p>
                  With the Unique Reference:
                </p>
                {referenceId ? (
                  <>
                    <p style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                      <span><b className="vt-accent">{referenceId}</b></span>
                      <CopyToClipboard
                        text={referenceId}
                        onCopy={() => this.copyConfirm('reference')}
                      >
                        <b
                          id='reference'
                          style={{cursor: 'pointer'}}
                        >
                          <FontAwesomeIcon
                            icon={faCopy}
                            className={'copy-icon'}
                          />
                        </b>
                      </CopyToClipboard>
                    </p>
                  </>
                ) : (
                  <>
                    <p style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                      <Loader small />
                      <b>
                        <FontAwesomeIcon
                          icon={faCopy}
                          className={'copy-icon'}
                          style={{opacity: 0.25}}
                        />
                      </b>
                    </p>
                  </>
                )}
              </div>
              <div className="small-12">
              </div>
            </div>
            <div className="grid-x" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <p style={{margin: 0, opacity: 0.8}}>
                You already accepted the Terms and Conditions
              </p>
              <button
                className="button vlt-button sm-b auto-wide dark-b"
                style={{flexDirection: 'column', fontWeight: 'normal'}}
                type="button"
                onClick={() => this.toggleTerms()}
              >
                Show terms
              </button>
            </div>
          </div>
        ) : (
          <div className="cell panel small-12 medium-8 large-7">
            <h2 style={{marginTop: 0, marginBottom: 0}}>
              Terms and Conditions
            </h2>
            <hr />
            <div className="grid-x">
              <ul style={{display: 'flex', flexDirection: 'column', gap: '12px', paddingLeft: 12, marginTop: 0}}>
                <li>
                  We only accept Euro.
                </li>
                <li>
                  The minimum purchase amount is €5000. If less is deposited it will be returned minus a fee of €50.
                </li>
                <li>
                  The purchase is exempt from right of withdrawal.
                </li>
                <li>
                  Currently, gold purchased with Euros cannot be sold directly for Euros. However, you can still trade it through our standard channels.
                </li>
                <li>
                  A fixed handling fee of €25 per transfer will be deducted .
                </li>
                <li>
                  A 4% premium will be added to the price of Gold at the time of trading.
                </li>
                <li>
                  Trading will take place during business hours (10-17 UTC+1) on weekdays (Mo-Fr).
                </li>
                <li>
                  The bank transfer will be made to Sequoyah Vaulting, our Gold and vaulting partner.
                </li>
              </ul>
            </div>
            <div className="grid-x">
              <button
                className="button vlt-btn vlt-green auto-wide"
                style={{flexDirection: 'column', fontWeight: 'normal'}}
                type="button"
                onClick={() => this.toggleTerms()}
              >
                  Show bank account information and<br/>
                  <b style={{paddingTop: '2px'}}>Accept the terms of purchase</b>
              </button>
            </div>
          </div>
        )}

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  automations: state.automation.automations,
  loading: state.automation.loading,
  errors: state.automation.errors,
  success: state.automation.success,
  eurDeposits: state.eurtrade.eurDeposits,
  marketAsset: state.market.asset,
  marketAssetLoading: state.market.assetLoading,
  assetValue: state.order.assetValue,
  automationLogs: state.automation.logs,
  eurTradeErrors: state.eurtrade.errors,
  trueLayer: state.eurtrade.trueLayer,
});

export default withRouter(connect(mapStateToProps)(EurTrade));
